export default {
  state: {
    menu: [],
    mainMenuType: { value: 2, COLLAPSED: 0, NARROW: 1, FULLWIDTH: 2 }
  },
  getters: {
    mainMenu: state => state.menu,
    mainMenuType: state => state.mainMenuType,
    mainMenuFindItemById: (state, getters) => (id) => {
      return getters._mainMenuFindItemById(state.menu, id)
    },
    _mainMenuFindItemById: (state, getters) => (menu, id) => {
      for (var i = 0; i < menu.length; i++) {
        if (menu[i].id === id) {
          return menu[i]
        }
        if (menu[i].children != null) {
          var result = getters._mainMenuFindItemById(menu[i].children, id)
          if (result !== null) {
            return result
          }
        }
      }
      return null
    },
    mainMenuFindItemByPath: (state, getters) => (path) => {
      return getters._mainMenuFindItemByPath(state.menu, path)
    },
    _mainMenuFindItemByPath: (state, getters) => (menu, path) => {
      for (var i = 0; i < menu.length; i++) {
        if (path.localeCompare(menu[i].path) === 0) {
          return menu[i]
        }
        if (menu[i].children != null) {
          var result = getters._mainMenuFindItemByPath(menu[i].children, path)
          if (result !== null) {
            return result
          }
        }
      }
      return null
    },
    mainMenuFindItemParent: (state, getters) => (id) => {
      return getters._mainMenuFindItemParent(state.menu, id)
    },
    _mainMenuFindItemParent: (state, getters) => (menu, id) => {
      for (var i = 0; i < menu.length; i++) {
        if (menu[i].id === id) {
          return true // нашли сам MenuItem
        }
        if (menu[i].children != null) {
          var result = getters._mainMenuFindItemParent(menu[i].children, id)
          if (result === true) {
            return menu[i] // выше возвращаем уже сам ParentMenuItem
          }
          if (result !== null) { // не трогая передаем выше ParentMenuItem
            return result
          }
        }
      }
      return null
    }
  },
  mutations: {
    mainMenuSet (state, value) {
      state.menu = value
    },
    mainMenuTypeSet (state, value) {
      state.mainMenuType.value = value
      localStorage.setItem('BMSClient.mainMenuType', value)
    },
    _mainMenuAddItem (state, {getters, ownerMenuItemId, newMenuItem}) {
      var ownerMenuItem = getters.mainMenuFindItemById(ownerMenuItemId)
      if (ownerMenuItem == null) {
        return null
      }
      return ownerMenuItem.children.push(newMenuItem)
    },
    _mainMenuDeleteItem (state, {getters, menuItemIdToDelete}) {
      var ownerMenuItem = getters.mainMenuFindItemParent(menuItemIdToDelete)
      if (ownerMenuItem === null) {
        return null
      }
      var ownerMenu
      if (ownerMenuItem === true) { // значит на удаление элемент из топового уровня меню
        ownerMenu = state.menu
      } else {
        ownerMenu = ownerMenuItem.children
      }

      var indxOfItemToDelete = -1
      for (var i = 0; i < ownerMenu.length; i++) {
        var menuItem = ownerMenu[i]
        if (menuItem.id === menuItemIdToDelete) {
          indxOfItemToDelete = i
          break
        }
      }
      if (indxOfItemToDelete === -1) {
        return null
      }
      ownerMenu.splice(indxOfItemToDelete, 1) // TODO: !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! весь массив перестраивается заново
      // ownerMenuItem.children[indxOfItemToDelete] = null
      return true
    }
  },
  actions: {
    mainMenuAddItem ({commit, getters}, {ownerMenuItemId, newMenuItem}) {
      commit('_mainMenuAddItem', {getters, ownerMenuItemId, newMenuItem})
    },
    mainMenuDeleteItem ({commit, getters}, menuItemIdToDelete) {
      commit('_mainMenuDeleteItem', {getters, menuItemIdToDelete})
    }
    /*
    incrementWithDelay ({ commit, state, getters, dispatch }, value) {
      setTimeout(() => {
        commit('increment', value)
      }, 2000)
    }
    */
  }
}



// WEBPACK FOOTER //
// ./src/store/storeMainMenu.js